(ns common.schema.entities.counterparty-diligence.person.core
  (:require [common.features.plan :as plan]
            [common.schema.entities.counterparty-diligence.person :as person-counterparty-diligence]
            [common.schema.entities.counterparty-diligence.util :as counterparty-diligence-util]))

;; Verbatim copy of common.schema.entity-types's existing
;; person-counterparty-diligence entry (entity_types.cljc:2445-2450, sharing
;; counterparty-diligence-read-check-fn at lines 505-529) - required here,
;; not there, to avoid a circular namespace dependency (entity_types.cljc
;; requires this registry). Keep in sync if the original ever changes. See
;; common.schema.entities.counterparty-diligence.company.core for why this
;; collapses to the simpler admin-only form (no :source-entity field here).
(defn- read-permissions-check-fn
  [{:keys [tenant tenant-plan role account-current-permissions]}]
  (and (plan/available :feature/counterparty-diligence tenant role tenant-plan)
       (contains? (:account-modules account-current-permissions)
                  :module/counterparty-diligence-admin)))

(def entity-type-definition
  {:entity-type                  :entity.type/person-counterparty-diligence
   :schema                       person-counterparty-diligence/schema
   :name                         {:en "Counterparty Diligence - Person"}
   :plural                       {:en "Person diligences"}
   :icon                         :fa-user-shield
   :create-icon                  :fa-user-shield
   :read-permissions-check-fn    read-permissions-check-fn
   :disable-permissions-check-fn counterparty-diligence-util/admin-delete-check-fn
   ;; No pre-existing legacy dedicated OpenSearch index at all for this
   ;; entity type - :search-index? left unset/true so the generic
   ;; materialization pipeline creates a genuinely new dedicated index, same
   ;; as company-counterparty-diligence/sale-agreement (see ai/mistakes.md).
   ;; The last default column (:screening-status, the kanban footer field)
   ;; was confirmed accessible for this dev tenant before reusing the legacy
   ;; column list verbatim - no tenant/field-configurations override exists
   ;; for this entity type at all - re-verify live if that ever changes (see
   ;; the fund-commitment kanban header/footer-field entry in
   ;; ai/mistakes.md).
   :search                       {:result/title-attr    :person-counterparty-diligence/person-name
                                  :list/default-columns [:person-counterparty-diligence/person-name
                                                         :counterparty-diligence/status
                                                         :person-counterparty-diligence/template
                                                         :counterparty-diligence/note
                                                         :person-counterparty-diligence/screening-status]
                                  :views {:grid {:po-default-field-paths [[:person-counterparty-diligence/person-name]
                                                                          [:counterparty-diligence/status]
                                                                          [:person-counterparty-diligence/template]
                                                                          [:counterparty-diligence/note]
                                                                          [:person-counterparty-diligence/screening-status]]
                                                 :mandatory-field-paths [[:person-counterparty-diligence/person-name]]}}}})
